export function shouldRedirectToPostLoginConversion(
  isSubscriber: boolean,
  isReturningUser: boolean,
  abbaEnabledPostLoginConversion: boolean
): boolean {
  return isReturningUser && abbaEnabledPostLoginConversion && !isSubscriber;
}
